import { AuthContainer } from "@recx/auth";
import { HttpProvider } from "@recx/auth";
import loader from "assets/images/loader.gif";
import logo from "assets/images/logo.svg";
import { datadogRum } from "@datadog/browser-rum";
import Home from "screens/Home";

function App() {
  let Originurl = window.location.origin.toString();

  let base_api = process.env.REACT_APP_API_URL;

  if (!Originurl.includes("localhost")) {
    datadogRum.init({
      applicationId: 'bf6d9bc0-5e46-492f-b95e-8ee3a50ed4ba',
      clientToken: 'pub725c73283c7fa7dd04e558c1bbeca02f',
      site: "datadoghq.com",
      service: process.env.REACT_APP_NAME,
      env: process.env.REACT_APP_ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sampleRate: 100,
      sessionReplaySampleRate: 100,
      trackInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "allow",
    });
  }
  return (
    <AuthContainer
      {...{
        baseUrl: `/`,
        client: "SSO",
        identityServerUrl: process.env.REACT_APP_Identity_URL,
        logo,
        loader,
        baseOriginUrl: process.env.REACT_APP_BASE_URL,
      }}
    >
      <HttpProvider apiUrl={base_api}>
        <Home />
      </HttpProvider>
    </AuthContainer>
  );
}

export default App;
